import FanAPI from 'watch-fanapi';

export const START_GET_FAN = 'START_GET_FAN';
export const COMPLETE_GET_FAN = 'COMPLETE_GET_FAN';

const fanApi = new FanAPI({ sourceHeader: 'espncom-watch' });

export function startGetFan() {
    return {
        type: START_GET_FAN,
        startTime: Date.now()
    };
}

export function completeGetFan(fan) {
    return {
        type: COMPLETE_GET_FAN,
        completeTime: Date.now(),
        fan
    };
}

export function getFan(swid) {
    return (dispatch) => {
        dispatch(startGetFan());
        return fanApi.getFanForId(swid).then((fan) => {
            dispatch(completeGetFan(fan));
            return fan;
        });
    };
}



// WEBPACK FOOTER //
// ./app/common/actions/fanActions.js